import * as React from 'react'
import { FC, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { defaultFilters } from '@user/store/opportunity/filters'
import { IOption } from '@user/components/Filters'
import { useSaveOpportunityFilters } from '@user/store/opportunity/hooks'

import { currencyString } from '@sales-center/common'
import { TotalAndDescription } from '../../../TotalAndDescription'

interface Props {
  count: number
  value: number
  salesTeam?: IOption
  salesTeams?: IOption[]
  assignee?: IOption
  assignees?: IOption[]
  canViewOpps: boolean
}

export const OpenOpportunities: FC<Props> = (props) => {
  const { count, value, salesTeams, assignees, canViewOpps } = props
  const navigate = useNavigate()

  const saveOpportunityFilters = useSaveOpportunityFilters()

  const callToAction = useCallback(() => {
    saveOpportunityFilters({
      ...defaultFilters,
      filters: {
        ...defaultFilters.filters,
        salesTeamIds: {
          ...defaultFilters.filters.salesTeamIds,
          value: { mode: 'any', options: salesTeams || [] },
        },
        assignee: {
          ...defaultFilters.filters.assignee,
          value: { mode: 'any', options: assignees || [] },
        },
      },
    })

    navigate('/opportunities')
  }, [assignees, navigate, salesTeams, saveOpportunityFilters])

  return (
    <TotalAndDescription
      testIdPrefix="opportunities-widget"
      callToActionFunction={callToAction}
      callToActionText="Follow Up"
      callToActionAllowed={canViewOpps}
      description={
        <>
          These Opportunities have a total value of{' '}
          <b>{`$${currencyString(value)}`}</b>. It&apos;s time to convert them
          into new Agreements.
        </>
      }
      headerText={`Open ${count == 1 ? 'Opportunity' : 'Opportunities'}`}
      total={count}
    />
  )
}

OpenOpportunities.displayName = 'OpenOpportunities'
